// removed by extract-text-webpack-plugin
module.exports = {"a_button":"Button__a_button___3p3iA","outerMargin":"Button__outerMargin___1CBsp","noMargin":"Button__noMargin___1a4iv","noMarginMobile":"Button__noMarginMobile___1dUxs","isLight":"Button__isLight___2YWRI","margin":"Button__margin___3XIpI","isPrimeLight":"Button__isPrimeLight___ewLzg","isDark":"Button__isDark___2Qt0Y","isLink":"Button__isLink___28ZPC","isMultiline":"Button__isMultiline___7_AlH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Button/Button.scss
// module id = 386
// module chunks = 0